import React, { useState, useEffect, useRef } from "react";
import apiService from "../../services/api_services.js";
import auth_service from "../../../src/services/auth_service";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import AddressesTab from "./AddressesTab.js";
import toast from "react-hot-toast";
import "primereact/resources/themes/lara-light-blue/theme.css"; // Choose your theme
import "primereact/resources/primereact.min.css"; // Core CSS
import "primeicons/primeicons.css"; // Icons
import { motion } from "framer-motion";
import OrdersList from "./ordersList.js";
// import { Share } from "lucide-react";
import { Share2 } from "lucide-react"; // Alternative: Try Send or ArrowUpRight
import { useCart } from "../../context/CartContext.js"; // Import the useCart hook
import PrescriptionModal from "./PrescriptionModal.js";
import sglogo from "../../assets/images/sglogo.png"; // Import SpectsGenie logo
import { dispatchProfileUpdate } from "../../utils/profileEvents.js"; // Import profile update utility
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editData, setEditData] = useState({});
  const navigate = useNavigate();
  const { setCartCount } = useCart(); // Use the setCartCount function from CartContext
  
  // Create frontend URL from environment variables - use BASE_URL_REF from .env
  const FRONTEND_URL = process.env.REACT_APP_BASE_URL_REF?.replace(/\/$/, '') || `http://${process.env.REACT_APP_HOST || 'localhost'}:${process.env.REACT_APP_PORT || '3000'}`;
  
  const tabs = [
    "Home",
    "Order History",
    "Prescriptions",
    "Addresses",
    "Account Information",
  ];
  const customerId = auth_service.getAccessTokenData()?.id;
  const location = useLocation();
  console.log("Full Location Object:", location);
  console.log("Location Search:", location.search); // Logs the query string
  const queryParams = new URLSearchParams(location.search);
  const tabFromQuery = queryParams.get("tab");
  const [copied, setCopied] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeTab, setActiveTab] = useState(
    tabFromQuery || "Account Information"
  );
  const [orderCount, setOrderCount] = useState(0);
  const [membershipNumber, setMembershipNumber] = useState('');
  const [showMembershipModal, setShowMembershipModal] = useState(false);
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [prescriptions, setPrescriptions] = useState([]);
  const [prescriptionLoading, setPrescriptionLoading] = useState(false);

  // Helper function to get tab icons
  const getTabIcon = (tab) => {
    const iconClass = "w-5 h-5";
    switch (tab) {
      case "Home":
        return <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" /></svg>;
      case "Order History":
        return <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v0a2 2 0 002 2h2m0 0h2a2 2 0 012 2v0a2 2 0 01-2 2H9m3 0h3a2 2 0 002-2v0a2 2 0 00-2-2h-3" /></svg>;
      case "Prescriptions":
        return <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" /></svg>;
      case "Addresses":
        return <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>;
      case "Account Information":
        return <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>;
      default:
        return <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>;
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tabFromQuery = queryParams.get("tab");
    console.log("Tab from Query:", tabFromQuery);
    if (tabFromQuery) {
      setActiveTab(tabFromQuery); // Automatically set the active tab
    }
  }, [location.search]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Check if customerId exists before making the API call
        if (customerId) {
          const response = await apiService.fetchProfileDetails(customerId);
          setUserData(response.data[0]);
          setEditData(response.data[0]);
          
          // Fetch order count
          try {
            const ordersResponse = await apiService.fetchOrdersById(customerId);
            setOrderCount(ordersResponse.data?.length || 0);
          } catch (orderError) {
            console.error("Error fetching orders:", orderError);
            setOrderCount(0);
          }
          
          // Generate membership number
          const membershipId = `GC${customerId.toString().padStart(6, '0')}`;
          setMembershipNumber(membershipId);
          
          // Fetch prescriptions
          await fetchPrescriptions();
        }
        setLoading(false);
      } catch (err) {
        setError("An error occurred while fetching the data.");
        setLoading(false);
      }
    };

    fetchData();
  }, [customerId]); // Add customerId as a dependency

  // Fetch prescriptions function
  const fetchPrescriptions = async () => {
    try {
      setPrescriptionLoading(true);
      if (customerId) {
        const response = await apiService.getPrescriptionByCustomerId(customerId);
        if (response.success) {
          console.log("Prescription data:", response.data); // Debug log
          setPrescriptions(response.data || []);
        }
      }
    } catch (error) {
      console.error("Error fetching prescriptions:", error);
      setPrescriptions([]);
    } finally {
      setPrescriptionLoading(false);
    }
  };

  // Utility function to safely get prescription values
  const getPrescriptionValue = (prescription, path) => {
    try {
      const parts = path.split('.');
      let current = prescription;
      
      // Handle case where prescription data might be a string
      if (typeof current.prescription === 'string') {
        try {
          current.prescription = JSON.parse(current.prescription);
        } catch (parseError) {
          console.error("Error parsing prescription JSON:", parseError);
          return 'N/A';
        }
      }
      
      for (const part of parts) {
        if (current && current[part] !== undefined && current[part] !== null && current[part] !== '') {
          current = current[part];
        } else {
          return 'N/A';
        }
      }
      return current || 'N/A';
    } catch (error) {
      console.error("Error getting prescription value:", error, "Path:", path);
      return 'N/A';
    }
  };

  // Handle prescription added
  const handlePrescriptionAdded = () => {
    fetchPrescriptions();
  };

  // Handle prescription delete
  const handleDeletePrescription = async (prescriptionId) => {
    try {
      const response = await apiService.deletePrescription(prescriptionId);
      if (response.success) {
        toast.success("Prescription deleted successfully", {
          duration: 3000,
          position: "top-center",
          style: {
            background: "#1F509A",
            color: "#fff",
          },
        });
        fetchPrescriptions();
      }
    } catch (error) {
      console.error("Error deleting prescription:", error);
      toast.error("Failed to delete prescription", {
        duration: 3000,
        position: "top-center",
      });
    }
  };

  // Handle prescription download
  const handleDownloadPrescription = async (prescriptionId, fileName) => {
    try {
      const blob = await apiService.downloadPrescription(prescriptionId);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName || 'prescription.pdf';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error("Error downloading prescription:", error);
      toast.error("Failed to download prescription", {
        duration: 3000,
        position: "top-center",
      });
    }
  };

  const handleDownloadPrescriptionPDF = async (prescription) => {
    try {
      // Create PDF content
      let prescriptionData = null;
      if (prescription.prescription) {
        // Check if it's already an object or a JSON string
        if (typeof prescription.prescription === 'string') {
          try {
            prescriptionData = JSON.parse(prescription.prescription);
          } catch (e) {
            console.error("Error parsing prescription JSON:", e);
            prescriptionData = null;
          }
        } else {
          prescriptionData = prescription.prescription;
        }
      }
      
      if (!prescriptionData) {
        toast.error("No prescription data available", {
          duration: 3000,
          position: "top-center",
        });
        return;
      }

      // Create a temporary div for PDF generation
      const tempDiv = document.createElement('div');
      tempDiv.style.position = 'absolute';
      tempDiv.style.left = '-9999px';
      tempDiv.style.top = '-9999px';
      tempDiv.style.width = '210mm';
      tempDiv.style.padding = '20mm';
      tempDiv.style.backgroundColor = '#ffffff';
      tempDiv.style.fontFamily = 'Arial, sans-serif';
      tempDiv.style.fontSize = '14px';
      tempDiv.style.lineHeight = '1.6';
      tempDiv.style.color = '#333';

      tempDiv.innerHTML = `
        <div style="text-align: center; border-bottom: 2px solid #1F509A; padding-bottom: 20px; margin-bottom: 30px;">
          <img src="${sglogo}" alt="SpectsGenie Logo" style="height: 60px; margin-bottom: 10px;" />
          <h1 style="color: #1F509A; margin: 10px 0; font-size: 28px;">SpectsGenie</h1>
          <h2 style="color: #1F509A; margin: 5px 0; font-size: 22px;">PRESCRIPTION DETAILS</h2>
          <p style="margin: 5px 0;"><strong>Date Created:</strong> ${new Date(prescription.created_at).toLocaleDateString()}</p>
          <p style="margin: 5px 0;"><strong>Prescription Name:</strong> ${prescription.prescription_name || 'Unnamed Prescription'}</p>
        </div>
        
        <div style="margin-bottom: 30px;">
          <h2 style="color: #1F509A; border-left: 4px solid #F59E0B; padding-left: 10px; margin-bottom: 20px;">Eye Measurements</h2>
          
          <div style="display: flex; justify-content: space-between; margin-bottom: 20px;">
            <div style="width: 48%; padding: 20px; border: 1px solid #ddd; border-radius: 8px;">
              <h3 style="color: #1F509A; margin-top: 0; margin-bottom: 15px;">👁 RIGHT EYE (OD)</h3>
              <div style="margin: 10px 0; padding: 8px; background: #f8f9fa; border-radius: 4px; display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">SPH (Sphere):</span>
                <span style="font-family: monospace;">${prescriptionData.right?.sph || 'N/A'}</span>
              </div>
              <div style="margin: 10px 0; padding: 8px; background: #f8f9fa; border-radius: 4px; display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">CYL (Cylinder):</span>
                <span style="font-family: monospace;">${prescriptionData.right?.cyl || 'N/A'}</span>
              </div>
              <div style="margin: 10px 0; padding: 8px; background: #f8f9fa; border-radius: 4px; display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">Axis:</span>
                <span style="font-family: monospace;">${prescriptionData.right?.axis || 'N/A'}</span>
              </div>
              <div style="margin: 10px 0; padding: 8px; background: #f8f9fa; border-radius: 4px; display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">ADD (Addition):</span>
                <span style="font-family: monospace;">${prescriptionData.right?.add || 'N/A'}</span>
              </div>
            </div>
            
            <div style="width: 48%; padding: 20px; border: 1px solid #ddd; border-radius: 8px;">
              <h3 style="color: #1F509A; margin-top: 0; margin-bottom: 15px;">👁 LEFT EYE (OS)</h3>
              <div style="margin: 10px 0; padding: 8px; background: #f8f9fa; border-radius: 4px; display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">SPH (Sphere):</span>
                <span style="font-family: monospace;">${prescriptionData.left?.sph || 'N/A'}</span>
              </div>
              <div style="margin: 10px 0; padding: 8px; background: #f8f9fa; border-radius: 4px; display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">CYL (Cylinder):</span>
                <span style="font-family: monospace;">${prescriptionData.left?.cyl || 'N/A'}</span>
              </div>
              <div style="margin: 10px 0; padding: 8px; background: #f8f9fa; border-radius: 4px; display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">Axis:</span>
                <span style="font-family: monospace;">${prescriptionData.left?.axis || 'N/A'}</span>
              </div>
              <div style="margin: 10px 0; padding: 8px; background: #f8f9fa; border-radius: 4px; display: flex; justify-content: space-between;">
                <span style="font-weight: bold;">ADD (Addition):</span>
                <span style="font-family: monospace;">${prescriptionData.left?.add || 'N/A'}</span>
              </div>
            </div>
          </div>
        </div>
        
        ${prescriptionData.pd || prescriptionData.rightPD || prescriptionData.leftPD ? `
        <div style="margin-top: 20px; padding: 15px; background: #f0f8ff; border-radius: 8px;">
          <h3 style="color: #1F509A; margin-top: 0;">📏 PD (Pupillary Distance)</h3>
          ${prescriptionData.pd ? `<p style="margin: 5px 0;"><strong>Single PD:</strong> ${prescriptionData.pd}mm</p>` : ''}
          ${prescriptionData.rightPD || prescriptionData.leftPD ? 
            `<p style="margin: 5px 0;"><strong>Right PD:</strong> ${prescriptionData.rightPD || 'N/A'}mm | <strong>Left PD:</strong> ${prescriptionData.leftPD || 'N/A'}mm</p>` : ''}
        </div>
        ` : ''}
        
        <div style="margin-top: 40px; text-align: center; font-size: 12px; color: #666; border-top: 1px solid #eee; padding-top: 20px;">
          <p style="margin: 5px 0;">Generated on ${new Date().toLocaleString()}</p>
          <p style="margin: 5px 0; font-weight: bold; color: #1F509A;">SpectsGenie - Your Vision, Our Mission</p>
        </div>
      `;

      document.body.appendChild(tempDiv);

      // Generate PDF using html2canvas and jsPDF
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        backgroundColor: '#ffffff'
      });

      document.body.removeChild(tempDiv);

      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;

      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      pdf.save(`prescription-${(prescription.prescription_name || 'unnamed').replace(/[^a-z0-9]/gi, '_').toLowerCase()}-${new Date().getTime()}.pdf`);

      toast.success("Prescription downloaded as PDF", {
        duration: 3000,
        position: "top-center",
      });
    } catch (error) {
      console.error("Error downloading prescription as PDF:", error);
      toast.error("Failed to download prescription as PDF", {
        duration: 3000,
        position: "top-center",
      });
    }
  };

  const handleDownloadPrescriptionText = async (prescription) => {
    try {
      // Create text content
      let prescriptionData = null;
      if (prescription.prescription) {
        // Check if it's already an object or a JSON string
        if (typeof prescription.prescription === 'string') {
          try {
            prescriptionData = JSON.parse(prescription.prescription);
          } catch (e) {
            console.error("Error parsing prescription JSON:", e);
            prescriptionData = null;
          }
        } else {
          prescriptionData = prescription.prescription;
        }
      }
      
      if (!prescriptionData) {
        toast.error("No prescription data available", {
          duration: 3000,
          position: "top-center",
        });
        return;
      }

      // Create content with proper ASCII characters only to avoid encoding issues
      const content = `================================================================================
                             PRESCRIPTION DETAILS
                                 SpectsGenie
================================================================================

Date Created: ${new Date(prescription.created_at).toLocaleDateString()}
Prescription Name: ${prescription.prescription_name || 'Unnamed Prescription'}
Generated: ${new Date().toLocaleString()}

================================================================================
                              EYE MEASUREMENTS
================================================================================

RIGHT EYE (OD)
-------------------------------------------------------------------------------
SPH (Sphere):           ${(prescriptionData.right?.sph || 'N/A').toString().padEnd(20)}
CYL (Cylinder):         ${(prescriptionData.right?.cyl || 'N/A').toString().padEnd(20)}
Axis:                   ${(prescriptionData.right?.axis || 'N/A').toString().padEnd(20)}
ADD (Addition):         ${(prescriptionData.right?.add || 'N/A').toString().padEnd(20)}

LEFT EYE (OS)
-------------------------------------------------------------------------------
SPH (Sphere):           ${(prescriptionData.left?.sph || 'N/A').toString().padEnd(20)}
CYL (Cylinder):         ${(prescriptionData.left?.cyl || 'N/A').toString().padEnd(20)}
Axis:                   ${(prescriptionData.left?.axis || 'N/A').toString().padEnd(20)}
ADD (Addition):         ${(prescriptionData.left?.add || 'N/A').toString().padEnd(20)}

${prescriptionData.pd || prescriptionData.rightPD || prescriptionData.leftPD ? `
================================================================================
                         PD (PUPILLARY DISTANCE)
================================================================================
${prescriptionData.pd ? `Single PD:              ${prescriptionData.pd}mm` : ''}
${prescriptionData.rightPD || prescriptionData.leftPD ? 
  `Right PD:               ${prescriptionData.rightPD || 'N/A'}mm\nLeft PD:                ${prescriptionData.leftPD || 'N/A'}mm` : ''}
` : ''}

================================================================================
                               NOTES
================================================================================
- SPH (Sphere): Corrects nearsightedness (-) or farsightedness (+)
- CYL (Cylinder): Corrects astigmatism
- Axis: Direction of astigmatism correction (0-180 degrees)
- ADD (Addition): Additional magnifying power for reading (bifocals/progressives)
- PD (Pupillary Distance): Distance between pupils in millimeters

================================================================================
Generated by SpectsGenie | ${new Date().toLocaleString()}
Your Vision, Our Mission
================================================================================`;

      // Fix encoding by explicitly setting UTF-8 and using proper BOM
      const BOM = '\uFEFF';
      const contentWithBOM = BOM + content;
      const blob = new Blob([contentWithBOM], { 
        type: 'text/plain;charset=utf-8' 
      });
      
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `prescription-${(prescription.prescription_name || 'unnamed').replace(/[^a-z0-9]/gi, '_').toLowerCase()}-${new Date().getTime()}.txt`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);

      toast.success("Prescription downloaded as text file", {
        duration: 3000,
        position: "top-center",
      });
    } catch (error) {
      console.error("Error downloading prescription as text:", error);
      toast.error("Failed to download prescription as text", {
        duration: 3000,
        position: "top-center",
      });
    }
  };

  const handleLogout = () => {
    auth_service.logout();
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    localStorage.removeItem("cart");
    localStorage.removeItem("wishlist");
    setCartCount(0); // Update the cart count
    navigate("/");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditData({ ...editData, [name]: value });
  };

  const handleUpdate = async () => {
    try {
      const user = {
        name: editData.name || userData.name,
        email: editData.email || userData.email,
        mobile: editData.mobile || userData.mobile,
        id: customerId,
      };
      const response = await apiService.editProfile(user);
      if (response.success === true) {
        // Update userData with merged data and handle name field properly
        const nameField = editData.name || userData.name || '';
        const nameParts = nameField.trim().split(' ').filter(part => part.length > 0);
        
        const updatedUserData = {
          ...userData,
          ...editData,
          // Always ensure we have the proper name fields for the header
          name: nameField,
          first_name: nameParts[0] || '',
          last_name: nameParts.slice(1).join(' ') || ''
        };
        
        setUserData(updatedUserData);
        console.log("Original userData:", userData);
        console.log("editData:", editData);
        console.log("Final updatedUserData for header:", updatedUserData);
        
        // Dispatch profile update event with updated data to notify header
        dispatchProfileUpdate(updatedUserData);
        toast.success("Details updated successfully", {
          duration: 3000,
          position: "top-center",
          style: {
            background: "#333",
            color: "#fff",
          },
        });
      } else {
        toast.error("Something went wrong", {
          duration: 3000,
          position: "top-center",
          style: {
            background: "#333",
            color: "#fff",
          },
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  if (loading) {
    return <p className="text-center text-lg text-gray-500">Loading...</p>;
  }

  if (error) {
    return <p className="text-red-500 text-center">{error}</p>;
  }

  if (!userData) {
    return <p className="text-center text-gray-500">No user data available.</p>;
  }

  const copyToClipboard = () => {
    const referralUrl = `${FRONTEND_URL}/signin?referralCode=${userData.referral_code}&customerId=${customerId}`;
    navigator.clipboard.writeText(referralUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
    
    console.log("Referral URL copied:", referralUrl);
    toast.success("Referral link copied to clipboard!", {
      duration: 2000,
      position: "top-center",
      style: {
        background: "#1F509A",
        color: "#fff",
      },
    });
  };

  const shareOnWhatsapp = () => {
    const referralUrl = `${FRONTEND_URL}/signin?referralCode=${userData.referral_code}&customerId=${customerId}`;
    console.log("WhatsApp Referral URL:", referralUrl); // Debug log
    
    const message = encodeURIComponent(
      `👋 Hey! I found this amazing eyewear store - SpectsGenie! 🕶️\n\n` +
      `✨ Use my referral code: *${userData.referral_code}* for special benefits and exclusive discounts!\n\n` +
      `🎁 Why you'll love SpectsGenie:\n` +
      `• Premium quality frames & sunglasses\n` +
      `• Contact lenses with great deals\n` +
      `• Virtual try-on feature\n` +
      `• Home delivery & easy returns\n\n` +
      `👓 Sign up here: ${referralUrl}\n\n` +
      `Trust me, you won't regret it! Let's upgrade our eyewear game together! 💫`
    );
    const whatsappUrl = `https://wa.me/?text=${message}`;
    
    try {
      window.open(whatsappUrl, '_blank');
      toast.success("WhatsApp sharing opened!", {
        duration: 2000,
        position: "top-center",
        style: {
          background: "#25D366",
          color: "#fff",
        },
      });
    } catch (error) {
      console.error("Error opening WhatsApp:", error);
      toast.error("Failed to open WhatsApp", {
        duration: 2000,
        position: "top-center",
      });
    }
  };

  const shareOnTelegram = () => {
    const referralUrl = `${FRONTEND_URL}/signin?referralCode=${userData.referral_code}&customerId=${customerId}`;
    const message = encodeURIComponent(
      `👋 Hey! I found this amazing eyewear store - SpectsGenie! 🕶️\n\n` +
      `✨ Use my referral code: ${userData.referral_code} for special benefits and exclusive discounts!\n\n` +
      `🎁 Why you'll love SpectsGenie:\n` +
      `• Premium quality frames & sunglasses\n` +
      `• Contact lenses with great deals\n` +
      `• Virtual try-on feature\n` +
      `• Home delivery & easy returns\n\n` +
      `👓 Sign up here: ${referralUrl}\n\n` +
      `Trust me, you won't regret it! Let's upgrade our eyewear game together! 💫`
    );
    const telegramUrl = `https://t.me/share/url?url=${referralUrl}&text=${message}`;
    
    try {
      window.open(telegramUrl, '_blank');
      toast.success("Telegram sharing opened!", {
        duration: 2000,
        position: "top-center",
        style: {
          background: "#0088cc",
          color: "#fff",
        },
      });
    } catch (error) {
      console.error("Error opening Telegram:", error);
      toast.error("Failed to open Telegram", {
        duration: 2000,
        position: "top-center",
      });
    }
  };


  const shareReferral = async () => {
    const referralUrl = `${FRONTEND_URL}/signin?referralCode=${userData.referral_code}&customerId=${customerId}`;
    console.log("Share Now Referral URL:", referralUrl); // Debug log
    const shareTitle = "🕶️ Join SpectsGenie with My Referral Code!";
    const shareText = 
      `👋 Hey! I found this amazing eyewear store - SpectsGenie! 🕶️\n\n` +
      `✨ Use my referral code: ${userData.referral_code} for special benefits and exclusive discounts!\n\n` +
      `🎁 Why you'll love SpectsGenie:\n` +
      `• Premium quality frames & sunglasses\n` +
      `• Contact lenses with great deals\n` +
      `• Virtual try-on feature\n` +
      `• Home delivery & easy returns\n\n` +
      `👓 Sign up here: ${referralUrl}\n\n` +
      `Trust me, you won't regret it! Let's upgrade our eyewear game together! 💫`;

    // Check if Web Share API is supported
    if (navigator.share) {
      try {
        // Include the complete message with URL in text to ensure full message is shared
        await navigator.share({
          title: shareTitle,
          text: shareText,
        });
        
        // toast.success("Referral shared successfully!", {
        //   duration: 3000,
        //   position: "top-center",
        //   style: {
        //     background: "#1F509A",
        //     color: "#fff",
        //   },
        // });
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error("Error sharing:", error);
          toast.error("Failed to share", {
            duration: 2000,
            position: "top-center",
          });
        }
      }
    } else {
      // Fallback for browsers that don't support Web Share API
      if (navigator.clipboard) {
        try {
          await navigator.clipboard.writeText(shareText);
          toast.success("Referral message copied to clipboard!", {
            duration: 3000,
            position: "top-center",
            style: {
              background: "#1F509A",
              color: "#fff",
            },
          });
        } catch (err) {
          console.error('Failed to copy text: ', err);
          toast.error("Failed to copy referral message", {
            duration: 2000,
            position: "top-center",
          });
        }
      } else {
        // Ultimate fallback - show message in alert
        alert(`Please copy this referral message:\n\n${shareText}`);
        toast.info("Referral message displayed. Please copy manually.", {
          duration: 3000,
          position: "top-center",
        });
      }
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50">
      <div className="max-w-6xl mx-auto px-3 sm:px-4 lg:px-6 py-4">
        {/* Header Section */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-4"
        >
          <div className="bg-white rounded-xl shadow-lg p-4 sm:p-5">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
              <div className="flex items-center gap-3">
               
                <div>
                  <h1 className="text-lg sm:text-xl lg:text-2xl font-bold text-gray-800">
                    Welcome back, {userData.name || "User"}!
                  </h1>
                  <p className="text-gray-600 mt-1 text-sm">Manage your account and preferences</p>
                </div>
              </div>
              <motion.button
                onClick={handleLogout}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="flex items-center gap-2 bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white font-medium py-2 px-4 rounded-lg shadow-lg transition-all duration-200 text-sm"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Logout
              </motion.button>
            </div>
          </div>
        </motion.div>

        {/* Navigation */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="mb-4"
        >
          {/* Desktop Navigation */}
          <div className="hidden lg:block">
            <div className="bg-white rounded-2xl shadow-xl border border-amber-100 p-1">
              <div className="flex flex-wrap justify-center gap-1">
                {tabs.map((tab, index) => (
                  <motion.button
                    key={tab}
                    whileHover={{ scale: 1.02, y: -2 }}
                    whileTap={{ scale: 0.98 }}
                    className={`relative whitespace-nowrap font-semibold px-4 py-2 rounded-xl transition-all duration-300 text-sm ${
                      activeTab === tab
                        ? "text-white shadow-lg"
                        : "text-gray-600 hover:bg-amber-50 hover:text-blue-900"
                    }`}
                    style={{
                      background: activeTab === tab 
                        ? 'linear-gradient(135deg, #1F509A, #000066)' 
                        : 'transparent'
                    }}
                    onClick={() => setActiveTab(tab)}
                  >
                    {activeTab === tab && (
                      <motion.div
                        layoutId="activeTab"
                        className="absolute inset-0 bg-gradient-to-r from-blue-900 to-blue-800 rounded-xl"
                        style={{ background: 'linear-gradient(135deg, #1F509A, #000066)' }}
                        transition={{ type: "spring", bounce: 0.2, duration: 0.6 }}
                      />
                    )}
                    <span className="relative z-10 flex items-center gap-2">
                      {getTabIcon(tab)}
                      {tab}
                    </span>
                  </motion.button>
                ))}
              </div>
            </div>
          </div>

          {/* Mobile Navigation - Dropdown Style */}
          <div className="lg:hidden">
            <div className="bg-white rounded-2xl shadow-xl border border-amber-100 overflow-hidden">
              <motion.button
                whileTap={{ scale: 0.98 }}
                className="w-full p-4 flex items-center justify-between bg-gradient-to-r from-blue-900 to-blue-800 text-white"
                style={{ background: 'linear-gradient(to right, #1F509A, #000066)' }}
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              >
                <div className="flex items-center gap-3">
                  {getTabIcon(activeTab)}
                  <span className="font-semibold text-base">{activeTab}</span>
                </div>
                <motion.svg
                  animate={{ rotate: mobileMenuOpen ? 180 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="w-5 h-5 text-amber-300"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </motion.svg>
              </motion.button>

              <motion.div
                initial={false}
                animate={{ height: mobileMenuOpen ? "auto" : 0 }}
                transition={{ duration: 0.3 }}
                className="overflow-hidden"
              >
                <div className="p-3 space-y-2">
                  {tabs.map((tab, index) => (
                    <motion.button
                      key={tab}
                      initial={{ opacity: 0, x: -20 }}
                      animate={{ 
                        opacity: mobileMenuOpen ? 1 : 0,
                        x: mobileMenuOpen ? 0 : -20
                      }}
                      transition={{ delay: index * 0.1 }}
                      whileHover={{ scale: 1.02, x: 4 }}
                      whileTap={{ scale: 0.98 }}
                      className={`w-full flex items-center gap-3 p-3 rounded-xl font-medium transition-all duration-200 text-sm ${
                        activeTab === tab
                          ? "bg-blue-50 text-blue-900 border-2 border-blue-200"
                          : "text-gray-600 hover:bg-amber-50 hover:text-blue-900"
                      }`}
                      style={{
                        backgroundColor: activeTab === tab ? 'rgba(0, 0, 122, 0.05)' : undefined,
                        borderColor: activeTab === tab ? '#1F509A' : undefined,
                        color: activeTab === tab ? '#1F509A' : undefined
                      }}
                      onClick={() => {
                        setActiveTab(tab);
                        setMobileMenuOpen(false);
                      }}
                    >
                      {getTabIcon(tab)}
                      <span>{tab}</span>
                      {activeTab === tab && (
                        <motion.div
                          initial={{ scale: 0 }}
                          animate={{ scale: 1 }}
                          className="ml-auto w-2 h-2 bg-amber-500 rounded-full"
                        />
                      )}
                    </motion.button>
                  ))}
                </div>
              </motion.div>
            </div>
          </div>
        </motion.div>

        {/* Content Area */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="bg-white rounded-2xl shadow-xl border border-amber-100 overflow-hidden"
        >
        {activeTab === "Home" && (
          <div className="p-4 sm:p-5 bg-gradient-to-br from-slate-50 via-amber-50 to-orange-50">
            {/* Welcome Header */}
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-5"
            >
              <h2 className="text-xl sm:text-2xl font-bold bg-gradient-to-r from-blue-900 to-amber-600 bg-clip-text text-transparent mb-2">
                Welcome Back!
              </h2>
              <p className="text-gray-600 text-sm">Here's what's happening with your account</p>
            </motion.div>

            {/* Stats Cards */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-5">
              {/* Wallet Card */}
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                whileHover={{ scale: 1.02, y: -4 }}
                className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-2xl p-4 text-white shadow-xl"
                style={{ background: 'linear-gradient(135deg, #1F509A, #000066)' }}
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-1">SG-Wallet</h3>
                  <p className="text-blue-100 text-xs mb-2">Your reward points</p>
                  <div className="text-2xl font-bold text-amber-300">{userData?.wallet || 0}</div>
                  <div className="text-blue-100 text-xs">Points Available</div>
                </div>
              </motion.div>

              {/* Orders Card */}
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.1 }}
                whileHover={{ scale: 1.02, y: -4 }}
                className="bg-gradient-to-br from-green-500 to-emerald-600 rounded-2xl p-4 text-white shadow-xl"
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                    </svg>
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-1">Total Orders</h3>
                  <p className="text-green-100 text-xs mb-2">Lifetime purchases</p>
                  <div className="text-2xl font-bold">{orderCount}</div>
                  <div className="text-green-100 text-xs">Orders Placed</div>
                </div>
              </motion.div>

              {/* Membership Card - Conditional Gold/Non-Member Only */}
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.2 }}
                whileHover={{ scale: 1.02, y: -4 }}
                className={`rounded-2xl p-4 text-white shadow-xl cursor-pointer ${
                  userData?.genie_gold_member === 1
                    ? "bg-gradient-to-br from-yellow-500 via-yellow-600 to-orange-500"
                    : "bg-gradient-to-br from-gray-500 via-gray-600 to-gray-700"
                }`}
                onClick={() => userData?.genie_gold_member === 1 ? setShowMembershipModal(true) : navigate('/')}
              >
                <div className="flex items-center justify-between mb-3">
                  <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                    {userData?.genie_gold_member === 1 ? (
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z" />
                      </svg>
                    ) : (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                      </svg>
                    )}
                  </div>
                  {userData?.genie_gold_member === 1 && (
                    <div className="flex items-center text-white">
                      <span className="text-lg font-bold mr-1">👑</span>
                      <span className="text-xs font-semibold">GOLD</span>
                    </div>
                  )}
                </div>
                <div>
                  <h3 className="text-lg font-bold mb-1">
                    {userData?.genie_gold_member === 1 
                      ? "Genie Gold Member" 
                      : "Not a Genie Member"}
                  </h3>
                  <p className={`text-xs mb-2 ${
                    userData?.genie_gold_member === 1 
                      ? "text-yellow-100" 
                      : "text-gray-100"
                  }`}>
                    {userData?.genie_gold_member === 1 
                      ? "Premium membership" 
                      : "Join by placing your first order"}
                  </p>
                  <div className="text-2xl font-bold">
                    {userData?.genie_gold_member === 1 
                      ? userData?.member_ship_code || membershipNumber 
                      : "🎯"}
                  </div>
                  <div className={`text-xs ${
                    userData?.genie_gold_member === 1 
                      ? "text-yellow-100" 
                      : "text-gray-100"
                  }`}>
                    {userData?.genie_gold_member === 1 
                      ? "Click to view certificate" 
                      : "Click to start shopping & become a Gold Member!"}
                  </div>
                </div>
              </motion.div>
            </div>

            {/* Membership Information for Non-Gold Members */}
            {userData?.genie_gold_member !== 1 && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
                className="bg-gradient-to-br from-yellow-50 via-orange-50 to-red-50 rounded-2xl shadow-lg border-2 border-yellow-200 p-6 mb-5"
              >
                <div className="text-center mb-5">
                  <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <span className="text-2xl">👑</span>
                  </div>
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-yellow-600 to-orange-600 bg-clip-text text-transparent mb-2">
                    Become a Genie Gold Member!
                  </h3>
                  <p className="text-gray-700 text-sm max-w-2xl mx-auto">
                    Place your first order and automatically become a Genie Gold Member with exclusive benefits and privileges.
                  </p>
                </div>

                <div className="grid md:grid-cols-2 gap-5 mb-6">
                  {/* How to Become Gold Member */}
                  <div className="bg-white rounded-xl p-4 border border-yellow-200">
                    <h4 className="text-lg font-bold text-yellow-800 mb-3 flex items-center gap-2">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                      How to Join Gold Membership
                    </h4>
                    <div className="space-y-3">
                      <div className="flex items-start gap-3">
                        <div className="w-7 h-7 bg-yellow-500 text-white rounded-full flex items-center justify-center text-sm font-bold">1</div>
                        <p className="text-gray-700 text-sm">Browse our amazing eyewear collection</p>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-7 h-7 bg-yellow-500 text-white rounded-full flex items-center justify-center text-sm font-bold">2</div>
                        <p className="text-gray-700 text-sm">Add your favorite frames to cart</p>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-7 h-7 bg-yellow-500 text-white rounded-full flex items-center justify-center text-sm font-bold">3</div>
                        <p className="text-gray-700 text-sm">Complete your first order payment</p>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-7 h-7 bg-gradient-to-r from-yellow-400 to-orange-500 text-white rounded-full flex items-center justify-center text-sm font-bold">👑</div>
                        <p className="text-yellow-700 text-sm font-semibold">Instantly become a Genie Gold Member!</p>
                      </div>
                    </div>
                  </div>

                  {/* Gold Member Benefits */}
                  <div className="bg-white rounded-xl p-4 border border-yellow-200">
                    <h4 className="text-lg font-bold text-yellow-800 mb-3 flex items-center gap-2">
                      <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z" />
                      </svg>
                      Gold Member Benefits
                    </h4>
                    <ul className="text-sm text-gray-700 space-y-2">
                      <li className="flex items-center gap-2">
                        <span className="text-yellow-500">⭐</span>
                        VIP customer service
                      </li>
                      <li className="flex items-center gap-2">
                        <span className="text-yellow-500">⭐</span>
                        Exclusive gold member discounts
                      </li>
                      <li className="flex items-center gap-2">
                        <span className="text-yellow-500">⭐</span>
                        Priority support & faster responses
                      </li>
                      <li className="flex items-center gap-2">
                        <span className="text-yellow-500">⭐</span>
                        Early access to new arrivals
                      </li>
                      <li className="flex items-center gap-2">
                        <span className="text-yellow-500">⭐</span>
                        Enhanced warranty coverage
                      </li>
                      <li className="flex items-center gap-2">
                        <span className="text-yellow-500">⭐</span>
                        Exclusive gold member events
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="text-center">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={() => navigate('/')}
                    className="px-8 py-3 bg-gradient-to-r from-yellow-500 via-yellow-600 to-orange-500 text-white font-bold rounded-xl shadow-lg hover:from-yellow-600 hover:to-orange-600 transition-all duration-300 flex items-center gap-2 mx-auto"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                    </svg>
                    Start Shopping & Join Gold Club
                    <span className="text-lg">👑</span>
                  </motion.button>
                  <p className="text-xs text-gray-600 mt-2">
                    🎉 Your Gold membership starts immediately after your first purchase!
                  </p>
                </div>
              </motion.div>
            )}

            {/* Referral Program Section */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3 }}
              className="bg-white rounded-2xl shadow-lg border border-amber-200 p-4"
            >
              <div className="text-center mb-5">
                <h3 className="text-xl font-bold bg-gradient-to-r from-blue-900 to-amber-600 bg-clip-text text-transparent mb-2">
                  Referral Program
                </h3>
                <p className="text-gray-600 text-sm max-w-2xl mx-auto">
                  Share the love and earn rewards! Invite friends to join SpectGenie and get rewarded for every successful referral.
                </p>
              </div>

              <div className="grid lg:grid-cols-2 gap-5">
                {/* Left Column - How it Works */}
                <div className="space-y-4">
                  {userData?.referral_points && userData?.referral_points !== "0" && (
                    <motion.div
                      initial={{ scale: 0.95 }}
                      animate={{ scale: 1 }}
                      className="bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200 rounded-xl p-4"
                    >
                      <div className="flex items-center gap-3">
                        <div className="w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center">
                          <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" />
                          </svg>
                        </div>
                        <div>
                          <h4 className="text-lg font-bold text-green-800 mb-1">Congratulations!</h4>
                          <p className="text-green-700 text-sm">
                            You've earned <span className="font-bold text-lg">₹{userData.referral_points}</span> from referrals
                          </p>
                        </div>
                      </div>
                    </motion.div>
                  )}

                  <div className="bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200 rounded-xl p-4">
                    <h4 className="text-lg font-bold text-blue-900 mb-3 flex items-center gap-2">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                      </svg>
                      How It Works
                    </h4>
                    <div className="space-y-3">
                      <div className="flex items-start gap-3">
                        <div className="w-7 h-7 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold">1</div>
                        <p className="text-blue-800 text-sm">Share your unique referral code with friends</p>
                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-7 h-7 bg-blue-500 text-white rounded-full flex items-center justify-center text-sm font-bold">2</div>
                        <p className="text-blue-800 text-sm">They sign up on SpectsGenie</p>

                      </div>
                      <div className="flex items-start gap-3">
                        <div className="w-7 h-7 bg-amber-500 text-white rounded-full flex items-center justify-center text-sm font-bold">3</div>
                        <p className="text-blue-800 text-sm">You both earn <strong>₹50 reward points!</strong></p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Right Column - Referral Code */}
                <div>
                  <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-200 rounded-xl p-4">
                    <div className="text-center mb-4">
                      <h4 className="text-lg font-bold text-gray-800 mb-3">Your Referral Code</h4>
                      <motion.div
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                        className="relative inline-block"
                        onClick={copyToClipboard}
                      >
                        <div className="bg-gradient-to-r from-blue-900 to-blue-800 text-white font-bold text-lg px-6 py-3 rounded-xl cursor-pointer shadow-xl border-4 border-amber-300"
                             style={{ background: 'linear-gradient(135deg, #1F509A, #000066)' }}>
                          <span>{copied ? "Copied!" : userData?.referral_code}</span>
                        </div>
                        <div className="absolute -top-2 -right-2 w-5 h-5 bg-amber-500 rounded-full flex items-center justify-center">
                          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                          </svg>
                        </div>
                      </motion.div>
                      <p className="text-xs text-gray-600 mt-2">Click the code above to copy it</p>
                    </div>

                   <div className="flex flex-col sm:flex-row gap-2">
  <motion.button
    whileHover={{ scale: 1.02 }}
    whileTap={{ scale: 0.98 }}
    onClick={copyToClipboard}
    className={`flex-1 flex items-center justify-center gap-2 py-2 rounded-lg font-semibold transition-all duration-200 text-sm ${
      copied 
        ? 'bg-green-500 text-white'
        : 'bg-white hover:bg-gray-50 text-gray-700 border-2 border-gray-200 hover:border-blue-300'
    }`}
  >
    {copied ? (
      <>
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        Copied!
      </>
    ) : (
      <>
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
        </svg>
        Copy Code
      </>
    )}
  </motion.button>

  <motion.button
    whileHover={{ scale: 1.02 }}
    whileTap={{ scale: 0.98 }}
    onClick={shareReferral}
    className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-blue-900 to-blue-800 text-white py-2 rounded-lg font-semibold shadow-lg transition-all duration-200 text-sm"
    style={{ background: 'linear-gradient(135deg, #1F509A, #000066)' }}
  >
    <Share2 size={16} className="text-amber-300" />
    Share Now
  </motion.button>

  <motion.button
    whileHover={{ scale: 1.02 }}
    whileTap={{ scale: 0.98 }}
    onClick={shareOnWhatsapp}
    className="flex-1 flex items-center justify-center gap-2 bg-green-500 text-white py-2 rounded-lg font-semibold shadow-lg transition-all duration-200 text-sm"
  >
    <svg
      className="w-5 h-5"
      fill="currentColor"
      viewBox="0 0 32 32"
    >
      <path d="M19.11 17.337c-.296-.148-1.76-.867-2.033-.965-.274-.098-.474-.148-.674.148s-.774.965-.949 1.163c-.173.197-.347.222-.643.074-.296-.148-1.25-.46-2.38-1.465-.879-.783-1.473-1.749-1.646-2.045-.173-.296-.018-.456.13-.603.134-.133.296-.347.444-.52.148-.173.197-.296.296-.494.098-.197.05-.37-.025-.52-.074-.148-.674-1.623-.923-2.222-.242-.583-.488-.503-.674-.513l-.573-.01c-.197 0-.52.074-.793.37-.274.296-1.04 1.017-1.04 2.48 0 1.462 1.065 2.875 1.213 3.072.148.197 2.1 3.207 5.08 4.496.71.307 1.264.49 1.694.626.712.227 1.36.195 1.872.118.571-.085 1.76-.718 2.008-1.41.247-.69.247-1.281.173-1.41-.074-.129-.271-.198-.567-.346zM16 3C9.373 3 4 8.373 4 15c0 2.656.891 5.102 2.382 7.07L4 29l7.215-2.343C13.09 27.7 14.509 28 16 28c6.627 0 12-5.373 12-12S22.627 3 16 3z"/>
    </svg>
    WhatsApp
  </motion.button>
</div>

                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        )}

        {activeTab === "Account Information" && (
          <div className="p-4 sm:p-5 bg-gradient-to-br from-slate-50 via-amber-50 to-orange-50">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-5"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-900 to-blue-800 rounded-full mb-3"
                   style={{ background: 'linear-gradient(135deg, #1F509A, #000066)' }}>
                <svg className="w-6 h-6 text-amber-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h2 className="text-xl font-bold bg-gradient-to-r from-blue-900 to-amber-600 bg-clip-text text-transparent mb-2">
                Account Information
              </h2>
              <p className="text-gray-600 text-sm">Manage your personal details and preferences</p>
            </motion.div>

            {/* User Info Cards */}
            <div className="max-w-4xl mx-auto space-y-4">
              {/* Profile Card */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="bg-white rounded-2xl shadow-xl border border-amber-100 overflow-hidden"
              >
                <div className="bg-gradient-to-r from-blue-900 to-blue-800 p-4 text-white"
                     style={{ background: 'linear-gradient(to right, #1F509A, #000066)' }}>
                  <h3 className="text-lg font-bold flex items-center gap-3">
                    <div className="w-6 h-6 bg-amber-500 rounded-full flex items-center justify-center">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
                      </svg>
                    </div>
                    Edit Profile Information
                  </h3>
                  <p className="text-blue-100 mt-1 text-sm">Update your account details below</p>
                </div>

                <div className="p-5">
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
                    {/* Personal Information */}
                    <div className="space-y-4">
                   <div>
  <label className="block text-sm font-bold text-gray-700 mb-2">
    Full Name <span className="text-red-500">*</span>
  </label>
  <div className="relative">
   
    <input
      type="text"
      name="name"
      value={editData.name || ""}
      onChange={handleInputChange}
      className="w-full pl-4 pr-4 py-3 border-2 border-gray-200 rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 focus:bg-white transition-all duration-200"
      placeholder="Enter your full name"
    />
  </div>
</div>



                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          Mobile Number <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                     
                          <input
                            type="text"
                            name="mobile"
                            value={editData.mobile || ""}
                            onChange={handleInputChange}
                            className="w-full pl-4 pr-4 py-3 border-2 border-gray-200 rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 focus:bg-white transition-all duration-200"
                            style={{ focusBorderColor: '#1F509A' }}
                            placeholder="Enter your mobile number"
                          />
                        </div>
                      </div>
                    </div>

                    {/* Contact Information */}
                    <div className="space-y-4">
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          Email Address <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg className="h-4 w-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                            </svg>
                          </div>
                          <input
                            type="email"
                            name="email"
                            value={editData.email || ""}
                            onChange={handleInputChange}
                            className="w-full pl-10 pr-4 py-3 border-2 border-gray-200 rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-gray-50 focus:bg-white transition-all duration-200"
                            style={{ focusBorderColor: '#1F509A' }}
                            placeholder="Enter your email address"
                          />
                        </div>
                      </div>

                      {/* Account Stats */}
                      <div className="bg-gradient-to-br from-amber-50 to-orange-50 border-2 border-amber-200 rounded-xl p-4">
                        <h4 className="text-base font-bold text-gray-800 mb-3 flex items-center gap-2">
                          <svg className="w-4 h-4 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                          </svg>
                          Account Summary
                        </h4>
                        <div className="space-y-2">
                          <div className="flex justify-between items-center">
                            <span className="text-gray-600 text-sm">Wallet Balance:</span>
                            <span className="font-bold text-blue-900 text-sm">₹{userData?.wallet || 0}</span>
                          </div>
                          {/* <div className="flex justify-between items-center">
                            <span className="text-gray-600 text-sm">Referral Points:</span>
                            <span className="font-bold text-green-600 text-sm">₹{userData?.referral_points || 0}</span>
                          </div> */}
                          <div className="flex justify-between items-center">
                            <span className="text-gray-600 text-sm">Referral Code:</span>
                            <span className="font-mono font-bold text-amber-600 text-sm">{userData?.referral_code}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Action Buttons */}
                  <div className="mt-5 flex flex-col sm:flex-row gap-3 pt-4 border-t border-gray-200">
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={handleUpdate}
                      className="flex-1 flex items-center justify-center gap-2 text-white font-semibold py-3 px-6 rounded-xl shadow-lg transition-all duration-200"
                      style={{ background: 'linear-gradient(135deg, #1F509A, #000066)' }}
                    >
                      <svg className="w-4 h-4 text-amber-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      Update Information
                    </motion.button>
                    
                    
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        )}
        {activeTab === "Addresses" && <AddressesTab />}
        {activeTab === "Order History" && <OrdersList />}
        {activeTab === "Prescriptions" && (
          <div className="p-4 sm:p-5 bg-gradient-to-br from-slate-50 via-amber-50 to-orange-50">
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-5"
            >
              <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-900 to-blue-800 rounded-full mb-3"
                   style={{ background: 'linear-gradient(135deg, #1F509A, #000066)' }}>
                <svg className="w-6 h-6 text-amber-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
              </div>
              <div className="flex items-center justify-center gap-4 mb-4">
                <h2 className="text-xl font-bold bg-gradient-to-r from-blue-900 to-amber-600 bg-clip-text text-transparent">
                  Your Prescriptions
                </h2>
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => setShowPrescriptionModal(true)}
                  className="bg-gradient-to-r from-blue-900 to-blue-800 text-white px-4 py-2 rounded-lg font-semibold hover:shadow-lg transition-all duration-200 flex items-center gap-2 text-sm"
                  style={{ background: 'linear-gradient(to right, #1F509A, #000066)' }}
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                  </svg>
                  Add Prescription
                </motion.button>
              </div>
              <p className="text-gray-600 text-sm">Manage your saved prescription information</p>
            </motion.div>

            {prescriptionLoading ? (
              <div className="text-center py-8">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-900 mx-auto mb-4"></div>
                <p className="text-gray-600">Loading prescriptions...</p>
              </div>
            ) : prescriptions && prescriptions.length > 0 ? (
              <div className="max-w-4xl mx-auto space-y-4">
                {prescriptions.map((prescription, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.1 }}
                    whileHover={{ y: -4 }}
                    className="bg-white rounded-2xl shadow-xl border border-amber-100 overflow-hidden"
                  >
                    <div className="bg-gradient-to-r from-blue-900 to-blue-800 p-4 text-white"
                         style={{ background: 'linear-gradient(to right, #1F509A, #000066)' }}>
                      <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                          <div className="w-10 h-10 bg-amber-500 rounded-full flex items-center justify-center text-white font-bold text-lg">
                            {index + 1}
                          </div>
                          <div>
                            <h3 className="text-lg font-bold">
                              {prescription.prescription_name || `Prescription #${index + 1}`}
                            </h3>
                            <p className="text-blue-100 text-sm">
                              Created: {new Date(prescription.created_at).toLocaleDateString()}
                            </p>
                          </div>
                        </div>
                        <div className="flex gap-2 flex-wrap">
                          {prescription.prescription_file && (
                            <motion.button 
                              whileHover={{ scale: 1.1 }}
                              whileTap={{ scale: 0.9 }}
                              onClick={() => handleDownloadPrescription(prescription.id, prescription.prescription_name)}
                              className="p-3 bg-green-500/20 hover:bg-green-500/30 rounded-xl transition-colors"
                              title="Download Original File"
                            >
                              <svg className="w-5 h-5 text-green-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                              </svg>
                            </motion.button>
                          )}
                          <motion.button 
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            onClick={() => handleDownloadPrescriptionPDF(prescription)}
                            className="p-3 bg-blue-500/20 hover:bg-blue-500/30 rounded-xl transition-colors"
                            title="Download as PDF"
                          >
                            <svg className="w-5 h-5 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                            </svg>
                          </motion.button>
                          <motion.button 
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            onClick={() => handleDownloadPrescriptionText(prescription)}
                            className="p-3 bg-purple-500/20 hover:bg-purple-500/30 rounded-xl transition-colors"
                            title="Download as Text"
                          >
                            <svg className="w-5 h-5 text-purple-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                            </svg>
                          </motion.button>
                          <motion.button 
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            className="p-3 bg-white/20 hover:bg-white/30 rounded-xl transition-colors"
                            title="View Prescription"
                          >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                            </svg>
                          </motion.button>
                          <motion.button 
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                            onClick={() => handleDeletePrescription(prescription.id)}
                            className="p-3 bg-red-500/20 hover:bg-red-500/30 rounded-xl transition-colors"
                            title="Delete Prescription"
                          >
                            <svg className="w-5 h-5 text-red-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </motion.button>
                        </div>
                      </div>
                    </div>
                    
                    <div className="p-6">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-4">
                          <h4 className="font-semibold text-gray-800 flex items-center gap-2">
                            <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center">
                              <span className="text-blue-600 font-bold text-sm">R</span>
                            </div>
                            Right Eye (OD)
                          </h4>
                          <div className="bg-blue-50 rounded-2xl p-4 space-y-2">
                            <div className="flex justify-between">
                              <span className="text-gray-600">SPH:</span>
                              <span className="font-semibold">{getPrescriptionValue(prescription, 'prescription.right.sph')}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">CYL:</span>
                              <span className="font-semibold">{getPrescriptionValue(prescription, 'prescription.right.cyl')}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Axis:</span>
                              <span className="font-semibold">{getPrescriptionValue(prescription, 'prescription.right.axis')}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">ADD:</span>
                              <span className="font-semibold">{getPrescriptionValue(prescription, 'prescription.right.add')}</span>
                            </div>
                          </div>
                        </div>

                        <div className="space-y-4">
                          <h4 className="font-semibold text-gray-800 flex items-center gap-2">
                            <div className="w-6 h-6 bg-green-100 rounded-full flex items-center justify-center">
                              <span className="text-green-600 font-bold text-sm">L</span>
                            </div>
                            Left Eye (OS)
                          </h4>
                          <div className="bg-green-50 rounded-2xl p-4 space-y-2">
                            <div className="flex justify-between">
                              <span className="text-gray-600">SPH:</span>
                              <span className="font-semibold">{getPrescriptionValue(prescription, 'prescription.left.sph')}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">CYL:</span>
                              <span className="font-semibold">{getPrescriptionValue(prescription, 'prescription.left.cyl')}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">Axis:</span>
                              <span className="font-semibold">{getPrescriptionValue(prescription, 'prescription.left.axis')}</span>
                            </div>
                            <div className="flex justify-between">
                              <span className="text-gray-600">ADD:</span>
                              <span className="font-semibold">{getPrescriptionValue(prescription, 'prescription.left.add')}</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* PD Section */}
                      {(getPrescriptionValue(prescription, 'prescription.pd') !== 'N/A' || 
                        getPrescriptionValue(prescription, 'prescription.rightPD') !== 'N/A' || 
                        getPrescriptionValue(prescription, 'prescription.leftPD') !== 'N/A') && (
                        <div className="mt-6 bg-amber-50 border border-amber-200 rounded-2xl p-4">
                          {getPrescriptionValue(prescription, 'prescription.pd') !== 'N/A' ? (
                            <div className="flex justify-between items-center">
                              <span className="font-semibold text-gray-800">Pupillary Distance (PD):</span>
                              <span className="font-bold text-amber-700">{getPrescriptionValue(prescription, 'prescription.pd')} mm</span>
                            </div>
                          ) : (
                            <div className="space-y-2">
                              <h4 className="font-semibold text-gray-800">Individual PD Values:</h4>
                              <div className="grid grid-cols-2 gap-4">
                                {getPrescriptionValue(prescription, 'prescription.rightPD') !== 'N/A' && (
                                  <div className="flex justify-between">
                                    <span className="text-gray-600">Right PD:</span>
                                    <span className="font-semibold">{getPrescriptionValue(prescription, 'prescription.rightPD')} mm</span>
                                  </div>
                                )}
                                {getPrescriptionValue(prescription, 'prescription.leftPD') !== 'N/A' && (
                                  <div className="flex justify-between">
                                    <span className="text-gray-600">Left PD:</span>
                                    <span className="font-semibold">{getPrescriptionValue(prescription, 'prescription.leftPD')} mm</span>
                                  </div>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      )}

                      {/* Additional Info */}
                      {getPrescriptionValue(prescription, 'prescription.hasTwoPD') === true && (
                        <div className="mt-4 bg-blue-50 border border-blue-200 rounded-2xl p-3">
                          <div className="flex items-center gap-2">
                            <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                            </svg>
                            <span className="text-sm font-medium text-blue-800">Uses separate PD values for each eye</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </motion.div>
                ))}
              </div>
            ) : (
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                className="max-w-2xl mx-auto"
              >
                <div className="bg-white rounded-3xl shadow-xl border border-amber-100 p-12 text-center">
                  <div className="w-24 h-24 mx-auto mb-6 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center">
                    <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800 mb-3">No prescriptions yet</h3>
                  
                 
                </div>
              </motion.div>
            )}
          </div>
        )}
        </motion.div>
      </div>

      {/* Membership Modal - Gold Members Only */}
      {showMembershipModal && userData?.genie_gold_member === 1 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto"
          >
            <div className="relative text-white p-6 rounded-t-2xl bg-gradient-to-br from-yellow-500 via-yellow-600 to-orange-500">
              <button
                onClick={() => setShowMembershipModal(false)}
                className="absolute top-4 right-4 text-white hover:text-gray-200"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              
              <div className="text-center">
                <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14l-5-4.87 6.91-1.01L12 2z" />
                  </svg>
                </div>
                <div className="flex items-center justify-center gap-2 mb-2">
                  <h2 className="text-2xl font-bold">Genie Gold Membership</h2>
                  <span className="text-2xl">👑</span>
                </div>
                <p className="text-sm text-yellow-100">Premium Gold Membership</p>
              </div>
            </div>
            
            <div className="p-6 space-y-4">
              <div className="text-center">
                <div className="bg-gradient-to-r from-yellow-50 to-orange-50 border-2 border-yellow-300 rounded-xl p-4 mb-4">
                  <div className="text-2xl font-bold mb-2 text-yellow-600">
                    {userData?.member_ship_code || membershipNumber}
                  </div>
                  <div className="text-sm text-gray-600">Membership Code</div>
                </div>
                
                <div className="bg-gray-50 rounded-xl p-4 mb-4">
                  <h3 className="font-semibold text-gray-800 mb-2">Member Details</h3>
                  <div className="text-sm text-gray-600 space-y-1">
                    <div>Name: {userData?.name}</div>
                    <div>Email: {userData?.email}</div>
                    <div>Member Since: {new Date().getFullYear()}</div>
                    <div>Orders Placed: {orderCount}</div>
                    <div className="flex items-center justify-center mt-2 p-2 bg-yellow-100 rounded-lg">
                      <span className="text-yellow-800 font-semibold text-xs">👑 GOLD MEMBER STATUS</span>
                    </div>
                  </div>
                </div>
                
                <div className="bg-yellow-50 border-yellow-200 border rounded-xl p-4 mb-4">
                  <h3 className="font-semibold mb-2 text-yellow-800">Gold Membership Benefits</h3>
                  <ul className="text-sm space-y-1 text-left text-yellow-700">
                    <li>• Priority customer support</li>
                    <li>• Exclusive member discounts</li>
                    <li>• Early access to new products</li>
                    <li>• Free eye health consultations</li>
                    <li>• Special birthday offers</li>
                    <li>• ⭐ VIP customer service</li>
                    <li>• ⭐ Exclusive gold member events</li>
                    <li>• ⭐ Premium product previews</li>
                    <li>• ⭐ Enhanced warranty coverage</li>
                  </ul>
                </div>
              </div>
              
              <div className="flex flex-col gap-3">
                <button
                  onClick={() => {
                    const membershipCode = userData?.member_ship_code || membershipNumber;
                    
                    // Create canvas for membership card
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    // Set canvas dimensions (credit card ratio)
                    canvas.width = 1000;
                    canvas.height = 630;
                    
                    // Create luxurious gold background with multiple gradients
                    const mainGradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
                    mainGradient.addColorStop(0, '#FFD700'); // Pure Gold
                    mainGradient.addColorStop(0.25, '#FFC107'); // Bright Gold
                    mainGradient.addColorStop(0.5, '#FFB300'); // Medium Gold
                    mainGradient.addColorStop(0.75, '#FF8F00'); // Deep Gold
                    mainGradient.addColorStop(1, '#E65100'); // Rich Orange Gold
                    
                    // Fill background
                    ctx.fillStyle = mainGradient;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    
                    // Add luxury pattern overlay
                    const patternGradient = ctx.createRadialGradient(canvas.width/2, canvas.height/2, 0, canvas.width/2, canvas.height/2, canvas.width/2);
                    patternGradient.addColorStop(0, 'rgba(255, 255, 255, 0.1)');
                    patternGradient.addColorStop(0.5, 'rgba(255, 255, 255, 0.05)');
                    patternGradient.addColorStop(1, 'rgba(0, 0, 0, 0.1)');
                    ctx.fillStyle = patternGradient;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    
                    // Add geometric pattern
                    ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
                    ctx.lineWidth = 1;
                    for (let i = 0; i < canvas.width; i += 50) {
                      for (let j = 0; j < canvas.height; j += 50) {
                        ctx.beginPath();
                        ctx.moveTo(i, j);
                        ctx.lineTo(i + 25, j + 25);
                        ctx.moveTo(i + 25, j);
                        ctx.lineTo(i, j + 25);
                        ctx.stroke();
                      }
                    }
                    
                    // Create elegant curved borders with multiple layers
                    const borderRadius = 25;
                    
                    // Helper function to draw rounded rectangle
                    const drawRoundedRect = (x, y, width, height, radius) => {
                      ctx.beginPath();
                      ctx.moveTo(x + radius, y);
                      ctx.lineTo(x + width - radius, y);
                      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                      ctx.lineTo(x + width, y + height - radius);
                      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                      ctx.lineTo(x + radius, y + height);
                      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                      ctx.lineTo(x, y + radius);
                      ctx.quadraticCurveTo(x, y, x + radius, y);
                      ctx.closePath();
                    };
                    
                    // Outer curved border
                    ctx.strokeStyle = '#B8860B';
                    ctx.lineWidth = 8;
                    drawRoundedRect(4, 4, canvas.width - 8, canvas.height - 8, borderRadius);
                    ctx.stroke();
                    
                    // Middle curved border
                    ctx.strokeStyle = '#FFD700';
                    ctx.lineWidth = 4;
                    drawRoundedRect(12, 12, canvas.width - 24, canvas.height - 24, borderRadius - 4);
                    ctx.stroke();
                    
                    // Inner curved border
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.lineWidth = 2;
                    drawRoundedRect(20, 20, canvas.width - 40, canvas.height - 40, borderRadius - 8);
                    ctx.stroke();
                    
                    // Add luxury corner ornaments
                    const drawLuxuryCorner = (x, y, rotation) => {
                      ctx.save();
                      ctx.translate(x, y);
                      ctx.rotate(rotation);
                      
                      // Ornate corner design
                      ctx.strokeStyle = '#FFFFFF';
                      ctx.lineWidth = 3;
                      ctx.fillStyle = '#FFD700';
                      
                      // Draw ornate corner
                      ctx.beginPath();
                      ctx.moveTo(-30, -30);
                      ctx.quadraticCurveTo(-20, -35, -10, -30);
                      ctx.quadraticCurveTo(-5, -25, -10, -20);
                      ctx.quadraticCurveTo(-15, -15, -20, -20);
                      ctx.quadraticCurveTo(-25, -25, -30, -20);
                      ctx.quadraticCurveTo(-35, -25, -30, -30);
                      ctx.closePath();
                      ctx.fill();
                      ctx.stroke();
                      
                      ctx.restore();
                    };
                    
                    // Draw luxury corners
                    drawLuxuryCorner(40, 40, 0);
                    drawLuxuryCorner(canvas.width - 40, 40, Math.PI/2);
                    drawLuxuryCorner(canvas.width - 40, canvas.height - 40, Math.PI);
                    drawLuxuryCorner(40, canvas.height - 40, -Math.PI/2);
                    
                    // Load and add SpectsGenie logo
                    const logoImg = new Image();
                    logoImg.crossOrigin = 'anonymous';
                    logoImg.onload = () => {
                      // Draw logo with shadow effect
                      ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
                      ctx.shadowBlur = 5;
                      ctx.shadowOffsetX = 2;
                      ctx.shadowOffsetY = 2;
                      ctx.drawImage(logoImg, 60, 50, 140, 70);
                      ctx.shadowColor = 'transparent';
                      
                      // Continue with the rest of the card generation
                      generateRestOfCard();
                    };
                    logoImg.onerror = () => {
                      // Fallback: Draw text logo if image fails to load
                      ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
                      ctx.shadowBlur = 5;
                      ctx.shadowOffsetX = 2;
                      ctx.shadowOffsetY = 2;
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = 'bold 36px serif';
                      ctx.textAlign = 'left';
                      ctx.fillText('SpectsGenie', 60, 90);
                      ctx.shadowColor = 'transparent';
                      
                      generateRestOfCard();
                    };
                    logoImg.src = sglogo;
                    
                    const generateRestOfCard = () => {
                      // Add modern header section
                      const headerY = 120;
                      
                      // Create sleek header background
                      const headerGradient = ctx.createLinearGradient(0, headerY - 50, 0, headerY + 50);
                      headerGradient.addColorStop(0, 'rgba(255, 255, 255, 0.15)');
                      headerGradient.addColorStop(0.5, 'rgba(255, 255, 255, 0.08)');
                      headerGradient.addColorStop(1, 'rgba(255, 255, 255, 0.03)');
                      ctx.fillStyle = headerGradient;
                      ctx.fillRect(80, headerY - 50, canvas.width - 160, 100);
                      
                      // Italian-style title with elegant styling
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = 'bold 58px "Playfair Display", "Times New Roman", serif';
                      ctx.textAlign = 'center';
                      ctx.shadowColor = 'rgba(0, 0, 0, 0.4)';
                      ctx.shadowBlur = 12;
                      ctx.shadowOffsetX = 3;
                      ctx.shadowOffsetY = 3;
                      ctx.fillText('GOLD', canvas.width/2, headerY - 5);
                      
                      // Subtitle with Italian elegance
                      ctx.font = '300 36px "Playfair Display", "Times New Roman", serif';
                      ctx.letterSpacing = '8px';
                      ctx.fillText('MEMBERSHIP', canvas.width/2, headerY + 35);
                      ctx.shadowColor = 'transparent';
                      
                      // Add modern geometric lines
                      ctx.strokeStyle = '#FFFFFF';
                      ctx.lineWidth = 2;
                      ctx.beginPath();
                      // Left line
                      ctx.moveTo(150, headerY + 55);
                      ctx.lineTo(canvas.width/2 - 80, headerY + 55);
                      // Right line
                      ctx.moveTo(canvas.width/2 + 80, headerY + 55);
                      ctx.lineTo(canvas.width - 150, headerY + 55);
                      ctx.stroke();
                      
                      // Add modern accent dots
                      ctx.fillStyle = '#FFFFFF';
                      ctx.beginPath();
                      ctx.arc(canvas.width/2 - 40, headerY + 55, 4, 0, 2 * Math.PI);
                      ctx.fill();
                      ctx.beginPath();
                      ctx.arc(canvas.width/2, headerY + 55, 4, 0, 2 * Math.PI);
                      ctx.fill();
                      ctx.beginPath();
                      ctx.arc(canvas.width/2 + 40, headerY + 55, 4, 0, 2 * Math.PI);
                      ctx.fill();
                      
                      // Create elegant information panels
                      const panelY = 200;
                      const panelHeight = 180;
                      const leftPanelX = 60;
                      const rightPanelX = canvas.width/2 + 30;
                      const panelWidth = canvas.width/2 - 90;
                      
                      // Left panel background with curved corners
                      const leftPanelGradient = ctx.createLinearGradient(leftPanelX, panelY, leftPanelX, panelY + panelHeight);
                      leftPanelGradient.addColorStop(0, 'rgba(255, 255, 255, 0.15)');
                      leftPanelGradient.addColorStop(1, 'rgba(255, 255, 255, 0.05)');
                      ctx.fillStyle = leftPanelGradient;
                      drawRoundedRect(leftPanelX, panelY, panelWidth, panelHeight, 15);
                      ctx.fill();
                      
                      // Right panel background with curved corners
                      const rightPanelGradient = ctx.createLinearGradient(rightPanelX, panelY, rightPanelX, panelY + panelHeight);
                      rightPanelGradient.addColorStop(0, 'rgba(255, 255, 255, 0.15)');
                      rightPanelGradient.addColorStop(1, 'rgba(255, 255, 255, 0.05)');
                      ctx.fillStyle = rightPanelGradient;
                      drawRoundedRect(rightPanelX, panelY, panelWidth, panelHeight, 15);
                      ctx.fill();
                      
                      // Panel curved borders
                      ctx.strokeStyle = 'rgba(255, 255, 255, 0.3)';
                      ctx.lineWidth = 2;
                      drawRoundedRect(leftPanelX, panelY, panelWidth, panelHeight, 15);
                      ctx.stroke();
                      drawRoundedRect(rightPanelX, panelY, panelWidth, panelHeight, 15);
                      ctx.stroke();
                      
                      // Left panel content with Italian typography
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = '600 16px "Playfair Display", "Times New Roman", serif';
                      ctx.textAlign = 'left';
                      ctx.letterSpacing = '2px';
                      ctx.fillText('MEMBER NAME', leftPanelX + 20, panelY + 35);
                      
                      ctx.font = 'bold 28px "Playfair Display", "Times New Roman", serif';
                      ctx.fillStyle = '#1a1a1a';
                      ctx.shadowColor = 'rgba(255, 255, 255, 0.6)';
                      ctx.shadowBlur = 3;
                      ctx.letterSpacing = '1px';
                      ctx.fillText((userData?.name || 'Gold Member').toUpperCase(), leftPanelX + 20, panelY + 70);
                      ctx.shadowColor = 'transparent';
                      
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = '600 16px "Playfair Display", "Times New Roman", serif';
                      ctx.letterSpacing = '2px';
                      ctx.fillText('MEMBERSHIP ID', leftPanelX + 20, panelY + 110);
                      
                      ctx.font = 'bold 26px "Courier New", monospace';
                      ctx.fillStyle = '#1a1a1a';
                      ctx.shadowColor = 'rgba(255, 255, 255, 0.6)';
                      ctx.shadowBlur = 3;
                      ctx.letterSpacing = '2px';
                      ctx.fillText(membershipCode, leftPanelX + 20, panelY + 145);
                      ctx.shadowColor = 'transparent';
                      
                      // Right panel content with Italian typography
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = '600 16px "Playfair Display", "Times New Roman", serif';
                      ctx.textAlign = 'left';
                      ctx.letterSpacing = '2px';
                      ctx.fillText('MEMBER SINCE', rightPanelX + 20, panelY + 35);
                      
                      ctx.font = 'bold 28px "Playfair Display", "Times New Roman", serif';
                      ctx.fillStyle = '#1a1a1a';
                      ctx.shadowColor = 'rgba(255, 255, 255, 0.6)';
                      ctx.shadowBlur = 3;
                      ctx.letterSpacing = '1px';
                      ctx.fillText(new Date().getFullYear().toString(), rightPanelX + 20, panelY + 70);
                      ctx.shadowColor = 'transparent';
                      
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = '600 16px "Playfair Display", "Times New Roman", serif';
                      ctx.letterSpacing = '2px';
                      ctx.fillText('STATUS', rightPanelX + 20, panelY + 110);
                      
                      ctx.font = 'bold 26px "Playfair Display", "Times New Roman", serif';
                      ctx.fillStyle = '#1a1a1a';
                      ctx.shadowColor = 'rgba(255, 255, 255, 0.6)';
                      ctx.shadowBlur = 3;
                      ctx.letterSpacing = '1px';
                      ctx.fillText('PREMIUM GOLD', rightPanelX + 20, panelY + 145);
                      ctx.shadowColor = 'transparent';
                      
                      // Create luxury VIP badge
                      const badgeY = 420;
                      const badgeX = canvas.width/2 - 120;
                      const badgeWidth = 240;
                      const badgeHeight = 80;
                      
                      // Badge shadow
                      ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
                      ctx.shadowBlur = 15;
                      ctx.shadowOffsetX = 5;
                      ctx.shadowOffsetY = 5;
                      
                      // Badge background with luxury gradient and curved corners
                      const badgeGradient = ctx.createLinearGradient(badgeX, badgeY, badgeX, badgeY + badgeHeight);
                      badgeGradient.addColorStop(0, 'rgba(255, 255, 255, 0.95)');
                      badgeGradient.addColorStop(0.5, 'rgba(255, 255, 255, 0.85)');
                      badgeGradient.addColorStop(1, 'rgba(255, 255, 255, 0.75)');
                      ctx.fillStyle = badgeGradient;
                      drawRoundedRect(badgeX, badgeY, badgeWidth, badgeHeight, 20);
                      ctx.fill();
                      
                      ctx.shadowColor = 'transparent';
                      
                      // Badge ornate curved border
                      ctx.strokeStyle = '#B8860B';
                      ctx.lineWidth = 4;
                      drawRoundedRect(badgeX, badgeY, badgeWidth, badgeHeight, 20);
                      ctx.stroke();
                      
                      // Inner badge curved border
                      ctx.strokeStyle = '#FFD700';
                      ctx.lineWidth = 2;
                      drawRoundedRect(badgeX + 5, badgeY + 5, badgeWidth - 10, badgeHeight - 10, 15);
                      ctx.stroke();
                      
                      // Badge text with Italian styling
                      ctx.fillStyle = '#B8860B';
                      ctx.font = 'bold 32px "Playfair Display", "Times New Roman", serif';
                      ctx.textAlign = 'center';
                      ctx.shadowColor = 'rgba(255, 255, 255, 0.8)';
                      ctx.shadowBlur = 4;
                      ctx.letterSpacing = '3px';
                      ctx.fillText('VIP ACCESS', canvas.width/2, badgeY + 35);
                      
                      ctx.font = '600 18px "Playfair Display", "Times New Roman", serif';
                      ctx.letterSpacing = '2px';
                      ctx.fillText('PREMIUM BENEFITS', canvas.width/2, badgeY + 60);
                      ctx.shadowColor = 'transparent';
                      
                      // Add luxury decorative elements
                      const drawLuxuryCircle = (x, y, radius, opacity) => {
                        const circleGradient = ctx.createRadialGradient(x, y, 0, x, y, radius);
                        circleGradient.addColorStop(0, `rgba(255, 255, 255, ${opacity})`);
                        circleGradient.addColorStop(0.7, `rgba(255, 255, 255, ${opacity * 0.5})`);
                        circleGradient.addColorStop(1, `rgba(255, 255, 255, 0)`);
                        ctx.fillStyle = circleGradient;
                        ctx.beginPath();
                        ctx.arc(x, y, radius, 0, 2 * Math.PI);
                        ctx.fill();
                      };
                      
                      drawLuxuryCircle(850, 550, 50, 0.2);
                      drawLuxuryCircle(150, 550, 35, 0.15);
                      drawLuxuryCircle(750, 200, 25, 0.1);
                      drawLuxuryCircle(250, 300, 20, 0.1);
                      
                      // Add elegant Italian footer
                      ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
                      ctx.font = '600 20px "Playfair Display", "Times New Roman", serif';
                      ctx.textAlign = 'center';
                      ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
                      ctx.shadowBlur = 5;
                      ctx.letterSpacing = '1px';
                      ctx.fillText('SpectsGenie - Premium Eyewear Experience', canvas.width/2, 580);
                      
                      ctx.font = '300 16px "Playfair Display", "Times New Roman", serif';
                      ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
                      ctx.letterSpacing = '0.5px';
                      ctx.fillText('Thank you for being a valued Gold Member!', canvas.width/2, 605);
                      ctx.shadowColor = 'transparent';
                      
                      // Convert canvas to blob and download
                      canvas.toBlob((blob) => {
                        if (blob) {
                          const url = URL.createObjectURL(blob);
                          const link = document.createElement('a');
                          link.download = `SpectsGenie-Gold-Membership-${membershipCode}.png`;
                          link.href = url;
                          link.click();
                          URL.revokeObjectURL(url);
                          toast.success('Gold membership card downloaded successfully!');
                        } else {
                          toast.error('Error generating membership card. Please try again.');
                        }
                      }, 'image/png');
                    };
                  }}
                  className="w-full bg-gradient-to-r from-yellow-500 to-blue-600 text-white py-2 px-4 rounded-lg font-semibold hover:from-yellow-600 hover:to-blue-700 transition-all flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  Download Card
                </button>
                
                <button
                  onClick={() => {
                    const membershipCode = userData?.member_ship_code || membershipNumber;
                    
                    // Generate the same card for sharing
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    
                    // Set canvas dimensions (credit card ratio)
                    canvas.width = 1000;
                    canvas.height = 630;
                    
                    // Create luxurious gold background with multiple gradients
                    const mainGradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
                    mainGradient.addColorStop(0, '#FFD700'); // Pure Gold
                    mainGradient.addColorStop(0.25, '#FFC107'); // Bright Gold
                    mainGradient.addColorStop(0.5, '#FFB300'); // Medium Gold
                    mainGradient.addColorStop(0.75, '#FF8F00'); // Deep Gold
                    mainGradient.addColorStop(1, '#E65100'); // Rich Orange Gold
                    
                    // Fill background
                    ctx.fillStyle = mainGradient;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    
                    // Add luxury pattern overlay
                    const patternGradient = ctx.createRadialGradient(canvas.width/2, canvas.height/2, 0, canvas.width/2, canvas.height/2, canvas.width/2);
                    patternGradient.addColorStop(0, 'rgba(255, 255, 255, 0.1)');
                    patternGradient.addColorStop(0.5, 'rgba(255, 255, 255, 0.05)');
                    patternGradient.addColorStop(1, 'rgba(0, 0, 0, 0.1)');
                    ctx.fillStyle = patternGradient;
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    
                    // Add geometric pattern
                    ctx.strokeStyle = 'rgba(255, 255, 255, 0.1)';
                    ctx.lineWidth = 1;
                    for (let i = 0; i < canvas.width; i += 50) {
                      for (let j = 0; j < canvas.height; j += 50) {
                        ctx.beginPath();
                        ctx.moveTo(i, j);
                        ctx.lineTo(i + 25, j + 25);
                        ctx.moveTo(i + 25, j);
                        ctx.lineTo(i, j + 25);
                        ctx.stroke();
                      }
                    }
                    
                    // Create elegant curved borders with multiple layers
                    const borderRadius = 25;
                    
                    // Helper function to draw rounded rectangle
                    const drawRoundedRect = (x, y, width, height, radius) => {
                      ctx.beginPath();
                      ctx.moveTo(x + radius, y);
                      ctx.lineTo(x + width - radius, y);
                      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
                      ctx.lineTo(x + width, y + height - radius);
                      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
                      ctx.lineTo(x + radius, y + height);
                      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
                      ctx.lineTo(x, y + radius);
                      ctx.quadraticCurveTo(x, y, x + radius, y);
                      ctx.closePath();
                    };
                    
                    // Outer curved border
                    ctx.strokeStyle = '#B8860B';
                    ctx.lineWidth = 8;
                    drawRoundedRect(4, 4, canvas.width - 8, canvas.height - 8, borderRadius);
                    ctx.stroke();
                    
                    // Middle curved border
                    ctx.strokeStyle = '#FFD700';
                    ctx.lineWidth = 4;
                    drawRoundedRect(12, 12, canvas.width - 24, canvas.height - 24, borderRadius - 4);
                    ctx.stroke();
                    
                    // Inner curved border
                    ctx.strokeStyle = '#FFFFFF';
                    ctx.lineWidth = 2;
                    drawRoundedRect(20, 20, canvas.width - 40, canvas.height - 40, borderRadius - 8);
                    ctx.stroke();
                    
                    // Add luxury corner ornaments
                    const drawLuxuryCorner = (x, y, rotation) => {
                      ctx.save();
                      ctx.translate(x, y);
                      ctx.rotate(rotation);
                      
                      // Ornate corner design
                      ctx.strokeStyle = '#FFFFFF';
                      ctx.lineWidth = 3;
                      ctx.fillStyle = '#FFD700';
                      
                      // Draw ornate corner
                      ctx.beginPath();
                      ctx.moveTo(-30, -30);
                      ctx.quadraticCurveTo(-20, -35, -10, -30);
                      ctx.quadraticCurveTo(-5, -25, -10, -20);
                      ctx.quadraticCurveTo(-15, -15, -20, -20);
                      ctx.quadraticCurveTo(-25, -25, -30, -20);
                      ctx.quadraticCurveTo(-35, -25, -30, -30);
                      ctx.closePath();
                      ctx.fill();
                      ctx.stroke();
                      
                      ctx.restore();
                    };
                    
                    // Draw luxury corners
                    drawLuxuryCorner(40, 40, 0);
                    drawLuxuryCorner(canvas.width - 40, 40, Math.PI/2);
                    drawLuxuryCorner(canvas.width - 40, canvas.height - 40, Math.PI);
                    drawLuxuryCorner(40, canvas.height - 40, -Math.PI/2);
                    
                    // Load and add SpectsGenie logo
                    const logoImg = new Image();
                    logoImg.crossOrigin = 'anonymous';
                    logoImg.onload = () => {
                      // Draw logo with shadow effect
                      ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
                      ctx.shadowBlur = 5;
                      ctx.shadowOffsetX = 2;
                      ctx.shadowOffsetY = 2;
                      ctx.drawImage(logoImg, 60, 50, 140, 70);
                      ctx.shadowColor = 'transparent';
                      
                      // Continue with the rest of the card generation
                      generateCardForSharing();
                    };
                    logoImg.onerror = () => {
                      // Fallback: Draw text logo if image fails to load
                      ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
                      ctx.shadowBlur = 5;
                      ctx.shadowOffsetX = 2;
                      ctx.shadowOffsetY = 2;
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = 'bold 36px serif';
                      ctx.textAlign = 'left';
                      ctx.fillText('SpectsGenie', 60, 90);
                      ctx.shadowColor = 'transparent';
                      
                      generateCardForSharing();
                    };
                    logoImg.src = sglogo;
                    
                    const generateCardForSharing = () => {
                      // Add crown and "GOLD MEMBERSHIP" title
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = '50px serif';
                      ctx.textAlign = 'center';
                      ctx.fillText('👑', canvas.width/2, 80);
                      
                      ctx.shadowColor = 'rgba(0, 0, 0, 0.4)';
                      ctx.shadowBlur = 8;
                      ctx.shadowOffsetX = 3;
                      ctx.shadowOffsetY = 3;
                      ctx.font = 'bold 48px serif';
                      ctx.fillText('GOLD MEMBERSHIP', canvas.width/2, 140);
                      ctx.shadowColor = 'transparent';
                      
                      // Add elegant divider line
                      ctx.strokeStyle = '#FFFFFF';
                      ctx.lineWidth = 2;
                      ctx.beginPath();
                      ctx.moveTo(150, 160);
                      ctx.lineTo(canvas.width - 150, 160);
                      ctx.stroke();
                      
                      // Add membership details with elegant styling
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = 'bold 20px serif';
                      ctx.textAlign = 'left';
                      
                      // Member Name (Left)
                      ctx.fillText('MEMBER NAME', 80, 220);
                      ctx.font = 'bold 24px serif';
                      ctx.fillStyle = '#1a1a1a';
                      ctx.fillText((userData?.name || 'Gold Member').toUpperCase(), 80, 250);
                      
                      // Membership Code (Left)
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = 'bold 20px serif';
                      ctx.fillText('MEMBERSHIP ID', 80, 300);
                      ctx.font = 'bold 28px monospace';
                      ctx.fillStyle = '#1a1a1a';
                      ctx.fillText(membershipCode, 80, 330);
                      
                      // Member Since (Right)
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = 'bold 20px serif';
                      ctx.textAlign = 'right';
                      ctx.fillText('MEMBER SINCE', canvas.width - 80, 220);
                      ctx.font = 'bold 24px serif';
                      ctx.fillStyle = '#1a1a1a';
                      ctx.fillText(new Date().getFullYear().toString(), canvas.width - 80, 250);
                      
                      // Status (Right)
                      ctx.fillStyle = '#FFFFFF';
                      ctx.font = 'bold 20px serif';
                      ctx.fillText('STATUS', canvas.width - 80, 300);
                      ctx.font = 'bold 24px serif';
                      ctx.fillStyle = '#1a1a1a';
                      ctx.fillText('PREMIUM GOLD', canvas.width - 80, 330);
                      
                      // Add elegant VIP badge
                      const badgeX = canvas.width/2 - 100;
                      const badgeY = 380;
                      const badgeWidth = 200;
                      const badgeHeight = 60;
                      
                      // Badge background with gradient
                      const badgeGradient = ctx.createLinearGradient(badgeX, badgeY, badgeX, badgeY + badgeHeight);
                      badgeGradient.addColorStop(0, 'rgba(255, 255, 255, 0.9)');
                      badgeGradient.addColorStop(1, 'rgba(255, 255, 255, 0.7)');
                      ctx.fillStyle = badgeGradient;
                      ctx.fillRect(badgeX, badgeY, badgeWidth, badgeHeight);
                      
                      // Badge border
                      ctx.strokeStyle = '#B8860B';
                      ctx.lineWidth = 3;
                      ctx.strokeRect(badgeX, badgeY, badgeWidth, badgeHeight);
                      
                      // Badge text
                      ctx.fillStyle = '#B8860B';
                      ctx.font = 'bold 24px serif';
                      ctx.textAlign = 'center';
                      ctx.fillText('VIP ACCESS', canvas.width/2, badgeY + 25);
                      ctx.font = 'bold 14px serif';
                      ctx.fillText('PREMIUM BENEFITS', canvas.width/2, badgeY + 45);
                      
                      // Add decorative elements
                      ctx.fillStyle = 'rgba(255, 255, 255, 0.2)';
                      ctx.beginPath();
                      ctx.arc(750, 480, 40, 0, 2 * Math.PI);
                      ctx.fill();
                      
                      ctx.fillStyle = 'rgba(255, 255, 255, 0.15)';
                      ctx.beginPath();
                      ctx.arc(150, 480, 25, 0, 2 * Math.PI);
                      ctx.fill();
                      
                      // Add footer text
                      ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
                      ctx.font = 'bold 16px serif';
                      ctx.textAlign = 'center';
                      ctx.fillText('SpectsGenie - Premium Eyewear Experience', canvas.width/2, 520);
                      ctx.font = '12px serif';
                      ctx.fillText('Thank you for being a valued Gold Member!', canvas.width/2, 540);
                      
                      // Convert canvas to blob and share
                      canvas.toBlob(async (blob) => {
                        if (blob) {
                          const shareText = `🏆 I'm a proud Genie Gold Member! 👑 Membership Code: ${membershipCode}`;
                          
                          if (navigator.share && navigator.canShare) {
                            try {
                              const file = new File([blob], `SpectsGenie-Gold-Membership-${membershipCode}.png`, { type: 'image/png' });
                              
                              if (navigator.canShare({ files: [file] })) {
                                await navigator.share({
                                  title: "Genie Gold Membership",
                                  text: shareText,
                                  files: [file]
                                });
                                toast.success('Gold membership card shared successfully!');
                              } else {
                                // Fallback to sharing text only
                                await navigator.share({
                                  title: "Genie Gold Membership",
                                  text: shareText,
                                  url: window.location.href
                                });
                                toast.success('Gold membership details shared!');
                              }
                            } catch (error) {
                              if (error.name !== 'AbortError') {
                                console.error('Error sharing:', error);
                                // Fallback to clipboard
                                navigator.clipboard.writeText(shareText);
                                toast.success('Gold membership details copied to clipboard!');
                              }
                            }
                          } else {
                            // Fallback: Copy to clipboard and offer download
                            navigator.clipboard.writeText(shareText);
                            
                            // Also offer to download the image
                            const url = URL.createObjectURL(blob);
                            const link = document.createElement('a');
                            link.download = `SpectsGenie-Gold-Membership-${membershipCode}.png`;
                            link.href = url;
                            link.click();
                            URL.revokeObjectURL(url);
                            
                            toast.success('Gold membership details copied to clipboard and card downloaded!');
                          }
                        } else {
                          toast.error('Error generating membership card for sharing.');
                        }
                      }, 'image/png');
                    };
                  }}
                  className="w-full bg-gradient-to-r from-green-500 to-green-600 text-white py-2 px-4 rounded-lg font-semibold hover:from-green-600 hover:to-green-700 transition-all flex items-center justify-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.367 2.684 3 3 0 00-5.367-2.684z" />
                  </svg>
                  Share Card & Details
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      )}

      {/* Prescription Modal */}
      <PrescriptionModal
        isOpen={showPrescriptionModal}
        onClose={() => setShowPrescriptionModal(false)}
/*  */        onPrescriptionAdded={handlePrescriptionAdded}
      />
    </div>
  );
};

export default Profile;
